import type { ReactNode } from 'react'
import { Skeleton } from '@systemeio/components'

export const UserInfoPopoverSkeleton = (): ReactNode => (
  <div className="flex w-full flex-col items-start gap-10 p-[30px] sm:min-h-[250px] sm:flex-row">
    <Skeleton className="size-40 min-h-[160px] min-w-[160px] rounded-full" />
    <div className="flex w-full min-w-0 grow flex-col gap-3">
      <div className="flex w-full flex-row gap-2">
        <Skeleton className="h-9 basis-1/2 rounded-xs" />
        <Skeleton className="h-9 basis-1/2 rounded-xs" />
      </div>
      <Skeleton className="h-5 rounded-xs" />
      <Skeleton className="h-5 rounded-xs" />
      <Skeleton className="h-5 rounded-xs" />
    </div>
  </div>
)
